// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- This is the one place which does need to import it since we are wrapping it here.
import { memo } from "react";

type IdentityFunction = <T>(fn: T) => T;

/**
 * Use this in place of React.memo as it'll preserve any generics present on the component.
 */
export const typedMemo: IdentityFunction = memo;
